module.exports = __webpack_public_path__ + "media/components/riskregister/icons/project-fe7f16d660fc0affcd09e44bd05b26c4.png";